/**
 * @module Experience/Plan-Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// Core Libraries
import { Routes } from '@angular/router';

// Components
import { PlanDetailsComponent } from '@experience/shop/plan-details/components/plan-details.component';

export const PLAN_DETAILS_ROUTES: Routes = [
  {
    path: '',
    component: PlanDetailsComponent,
    runGuardsAndResolvers: 'pathParamsChange',
  },
];
